<template>
  <div class="all">
    <div style="width: 100%;height: 300px;">
      <div style="position:absolute; width: 99.15%; height: 60px; display: flex; align-items: center; justify-content: center;">
        <img src="../../public/logo.svg" alt="logo" style="position: absolute; width:10%; top: 35%; left: 25%"/>
        <div style="position:absolute; width:100%; top: 30%; height: 75%; font-weight: bold; font-size:20px; display: flex; align-items: center; justify-content: center; color: white">
          闪电心算
        </div>
      </div>
      <div style="position:absolute;display: flex;color: white; align-items: center; justify-content: center; width: 35%; height: 25%; top: 8%;left: 5%">
        <div style="position:absolute; height: 60%; width: 100%; font-size: 25px; font-weight: bold">
          口袋里的数学启蒙专家
        </div>
        <div style="position:absolute; height: 40%; top:60%;width: 100%; font-size: 10px">
          专为孩子们打造随时随地可学习练习的心算平台刻，我们的心算 APP，宛如一位贴心的数学导师，陪伴您的孩子开启奇妙心算之旅，全方位挖掘数学潜能，提升综合素养。
        </div>
      </div>
      <div style="position: absolute; width: 50%;height: 50%; top: 13%; left: 45%;">
        <img src="@/components/img/phone.svg" alt="logo" style="position: absolute; width: 100%; top: 8%"/>
        <img src="@/components/img/yellow1.svg" alt="logo" style="position: absolute; width: 5%; top: 17%; left: 1%"/>
        <img src="@/components/img/yellow2.svg" alt="logo" style="position: absolute; width: 3%; left: 70%; top: 4%"/>
      </div>
      <img src="@/components/img/bg.svg" alt="logo" style=" width: 100%;height: 98%;"/>
    </div>



    <div id="intro" style="width: 100%;height: 300px;">
      <div style="position:absolute; width: 100%; height: 300px;">
        <div style="display: flex;font-size: 25px; font-weight: bold; align-items: center; justify-content: center;text-align: center; position: absolute; width: 80%; height: 25%; left:10%; top: 10%">
          我们的速度心算APP具有很多强大的功能！
        </div>
        <div style=" position:absolute; width: 90%; height: 225px;left: 5%; top: 10%">
          <div style="position: absolute; width: 30%; height: 225px;">
            <div style="position:absolute;font-size: 12px; font-weight: bold; width: 100%; height: 10%;top: 40%;display: flex; justify-content: left">
              海量题库随心练
            </div>
            <div style="position:absolute;font-size: 10px; width: 100%; height: 42%;top: 58%;display: flex; justify-content: left">
              从基础一位数加减到六位数加减，速度心算内置了丰富多样的题型，满足不同学习时间段的需求，无论是刚接触速度心算还是夯实技巧，都能找到合适练习内容。
            </div>
          </div>
          <div style="position: absolute; width: 30%; height: 225px;left: 35%">
            <div style="position:absolute;font-size: 12px; font-weight: bold; width: 100%; height: 10%;top: 40%;display: flex; justify-content: left">
              实时反馈解析
            </div>
            <div style="position:absolute;font-size: 10px; width: 100%; height: 42%;top: 58%;display: flex; justify-content: left">
              在每一次练习完成的瞬间，结果便即刻呈现于眼前，这能够让你第一时间察觉到自己的错误思维，从而对其进行纠正，有效避免在后续的练习中重复犯下同样的错误。
            </div>
          </div>
          <div style="width: 30%;position: absolute;  height: 225px;left: 70%">
            <div style="position:absolute;font-size: 12px; font-weight: bold; width: 100%; height: 10%;top: 40%;display: flex; justify-content: left">
              个性化训练
            </div>
            <div style="position:absolute;font-size: 10px; width: 100%; height: 42%;top: 58%;display: flex; justify-content: left">
              每次练习后台会记录练习结果以及练习难度，会个性化生成训练方案，针对薄弱的环节进行强化训练。还可以根据自身情况，选择不同难度，题目自由搭配进行训练。
            </div>
          </div>
        </div>
      </div>
    </div>


    <div id="download" style="width: 100%;height: 300px; background: #3A65FF">
        <div style="position: absolute;color: white; width: 60%; height: 60px; left: 20%; top: 640px">
        <div style="display:flex;justify-content: center;align-items: center; position:absolute; width: 100%; height: 60%; font-size: 25px;font-weight: bold;">版本与下载</div>
        <div style="display:flex;justify-content: center;align-items: center; position:absolute; width: 100%; height: 40%; font-size: 10px;top: 60%">目前只支持网页下载，稍后会上架各个应用商店。</div>
      </div>
      <div style="position: absolute; width: 80%; height: 150px; left: 10%; top: 720px;">
        <el-card class="card" style="position:absolute; width: 45%; height: 100%;">
          <div style="position:absolute; width: 81%; left: 9.5%; height: 90%;top: 5%;">
            <div style="position:absolute; width: 100%; height: 15%;display:flex;justify-content: center;align-items: center; font-size: 15px;">
              体验版
            </div>
            <div style="position:absolute; width: 100%; height: 15%;top:15%; display:flex;justify-content: left;align-items: center; font-size: 15px; font-weight: bold">
              免费
            </div>
            <div style="position:absolute; width: 100%; height: 10%;top:18%;">
              <el-divider></el-divider>
            </div>
            <div style="position:absolute; width: 100%; height: 60%;top:40%;">
              <div style="position:absolute; width: 100%; height: 23%; display:flex;justify-content: left;align-items: center; ">
                <img src="@/components/img/right.svg" alt="logo" style=" width: 7%"/>
                <div style="font-size: 10px"> &nbsp;&nbsp;&nbsp;一到二位加减法</div>
              </div>
              <div style="position:absolute; width: 100%; height: 25%; top: 75%;display:flex;justify-content: center;align-items: center;" >
                <el-button type="danger" style="min-width: 80px; height: 25px;padding: 0" @click="simpleDownload">下载</el-button>
              </div>
            </div>
          </div>
        </el-card>
        <el-card style="position:absolute; width: 45%; height: 100%; left: 55%">
          <div style="position:absolute; width: 81%; left: 9.5%; height: 90%;top: 5%;">
            <div style="position:absolute; width: 100%; height: 15%;display:flex;justify-content: center;align-items: center; font-size: 15px;">
              完整版
            </div>
            <div style="position:absolute; width: 100%; height: 15%;top:15%; display:flex;justify-content: left;align-items: center; font-size: 15px; font-weight: bold">
              ￥30
            </div>
            <div style="color: rgba(0,0,0,0.5); position:absolute; width: 100%; height: 15%;top:25%; display:flex;justify-content: left;align-items: center; font-size: 5px;">
              一次购买永久解锁，需应用内购买
            </div>
            <div style="position:absolute; width: 100%; height: 10%;top:18%;">
              <el-divider></el-divider>
            </div>
            <div style="position:absolute; width: 100%; height: 60%;top:40%;">
              <div style="position:absolute; width: 100%; height: 32%; display:flex;justify-content: left;align-items: center; ">
                <img src="@/components/img/right.svg" alt="logo" style=" width: 7%"/>
                <div style="font-size: 10px"> &nbsp;&nbsp;&nbsp;一到六位加减法</div>
              </div>
              <div style="position:absolute; width: 100%; height: 32%; top:32%; display:flex;justify-content: left;align-items: center; ">
                <img src="@/components/img/right.svg" alt="logo" style=" width: 7%"/>
                <div style="font-size: 10px"> &nbsp;&nbsp;&nbsp;做题记录</div>
              </div>
              <div style="position:absolute; width: 100%; height: 32%; top:64%; display:flex;justify-content: left;align-items: center; ">
                <img src="@/components/img/right.svg" alt="logo" style=" width: 7%"/>
                <div style="font-size: 10px"> &nbsp;&nbsp;&nbsp;自定义题型训练</div>
              </div>
            </div>
          </div>
        </el-card>
      </div>
      <div style="position: absolute; width: 99%;height:auto; top: 893px; display:flex; justify-content: center; align-items: center">
        <img src="@/components/img/beian.png" alt="logo" style=" width: 10.8px; height: 12px; margin-right: 5px"/>
        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=21010602001191" style="color: black; font-size: 10px" rel="noreferrer" target="_blank">
          辽公网安备21010602001191号
        </a>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {

  },
  data() {
    return {
      logoSrc: require("../../public/logo.svg"),
    };
  },
  mounted() {
    // 监听滚动事件
    window.addEventListener('scroll', this.onScroll)
  },
  destroy() {
    // 必须移除监听器，不然当该vue组件被销毁了，监听器还在就会出错
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({behavior: 'smooth'});
      }
    },
    simpleDownload() {
      window.open(
          'https://www.zaohuiapp.cn:17002/download'
      );
    },
  }
}
</script>

<style scoped>
</style>
